import { SchemaValueFields } from '../models/schema-value-fielts.model';

// A single measurement is stored as a degenerate range (from === to); the unit comes from the feature's
// own label, e.g. "THICKNESS (MM)".
const extractUnitFromLabel = (label?: string | null): string => {
    const match = label?.match(/\(([^()]+)\)\s*$/);
    return match ? match[1].trim() : '';
};

export const formatFeatureValue = (value?: SchemaValueFields | null, featureLabel?: string | null): string => {
    if (!value) {
        return '-';
    }
    if (value.textValue) {
        return value.textValue;
    }
    if (value.enumValue) {
        return value.enumValue;
    }
    if (typeof value.booleanValue === 'boolean') {
        return value.booleanValue ? 'YES' : 'NO';
    }
    if (value.dateValue) {
        const date = value.dateValue instanceof Date ? value.dateValue : new Date(value.dateValue as unknown as string);
        return date.toISOString().slice(0, 10);
    }
    if (value.enumValues && value.enumValues.length > 0) {
        return value.enumValues.join(', ');
    }
    if (typeof value.numericValue === 'number') {
        return value.numericValue.toString();
    }
    if (typeof value.numericRangeFrom === 'number' && typeof value.numericRangeTo === 'number') {
        const unit = extractUnitFromLabel(featureLabel);
        if (value.numericRangeFrom === value.numericRangeTo) {
            return unit ? `${value.numericRangeFrom.toFixed(2)} ${unit}` : value.numericRangeFrom.toString();
        }
        return `${value.numericRangeFrom} - ${value.numericRangeTo}`;
    }
    return '-';
};
